// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_k7-0";
export var fileCarousel = "_k7-2";
export var removeFileButton = "_k7-1";